import {Intro, News, Community, Partners, Agent} from 'modules/blocks'
import {RussiaMap} from 'components/RussiaMap/RussiaMap';
import {useScreenSize} from '../helpers';

export const Main = () => {
    const { isMobile } = useScreenSize()
	return (
		<>
            <Intro />
            { isMobile && <RussiaMap /> }
            <Agent />
            { !isMobile && <RussiaMap /> }
            <News />
            <Community />
            <Partners />
        </>
	);
};
